/* eslint-disable no-restricted-imports */
import { useTransactionsQuery } from '~/client/components/Game/GameView/GameViewDesktop/GameBlock/GameFooter/UserFooter/QuickDepositButton/graphql/TransactionsQuery.generated';

const useLastTransactionData = (currencyConfig: CashierConfig) => {
  const transactions = useTransactionsQuery({
    skip: currencyConfig.type !== 'fiat',
    variables: {
      first: 1,
      txActions: ['DEPOSIT'],
      walletCurrencies: [currencyConfig.name ?? ''],
    },
  });

  const transaction =
    transactions.data?.banking?.myTransactions?.edges?.[0]?.node;

  return {
    provider: transaction?.provider,
    providerMethod: transaction?.providerMethod,
    amount: transaction?.amount,
  };
};

export default useLastTransactionData;
